import { HttpClient } from "../../http/HttpClient";
import { ApiResponse } from "../../api/types/ApiResponse";
import { ApiResponseHandler } from "../../http/services/handleApiResponse/handleApiResponse";
import saveMetadataUrl, {
  getMetadataDocumentsPreviewUrl,
} from "../../api/metadataBackendEndpoints/metadataBackendEndpoints";
import MetadataRepository from "@/core/customers/repositories/MetadataRepository";
import ViteEnv from "@/details/env/vite/ViteEnv";
import EnvKeys from "@/core/env/EnvKeys";
import { useAuthStore } from "@/core/stores/authStore";
import { MetadataResponseData } from "@/core/customers/entities/metaData";

export default class MetadataRepositoryBackend implements MetadataRepository {
  constructor(private readonly httpClient: HttpClient) { }

  async saveMetadataInfos(
    businessKey: string,
    body: object,
  ): Promise<MetadataResponseData | null> {
    const response = await this.httpClient.patch<
      ApiResponse<MetadataResponseData>,
      object
    >({
      url: saveMetadataUrl(businessKey),
      body,
      withAuth: true,
    });
    const result = ApiResponseHandler.handleResponse(response);
    return result.success && result.data ? result.data : null;
  }

  async getMetadataImgUrl(businessKey: string): Promise<string | null> {
    try {
      // Fetch binary data directly using fetch to handle blob response
      const env = new ViteEnv();
      const baseUrl = env.get(EnvKeys.BACKEND_BASE_URL);
      const path = getMetadataDocumentsPreviewUrl(businessKey);

      const finalUrl = baseUrl
        ? `${String(baseUrl).replace(/\/$/, "")}/${path.replace(/^\//, "")}`
        : path;

      const token = useAuthStore.getState().user?.token;

      const response = await fetch(finalUrl, {
        method: "GET",
        headers: token ? { "X-App-Token": `Bearer ${token}` } : undefined,
      });

      if (!response.ok) {
        console.error("Error fetching metadata image:", response.status, response.statusText);
        return null;
      }

      // Get the binary data as a blob
      const blob = await response.blob();

      // Create a blob URL from the binary data
      const blobUrl = URL.createObjectURL(blob);

      // console.log("Blob URL created:", blobUrl);

      return blobUrl;
    } catch (error) {
      console.error("Error getting metadata image URL:", error);
      return null;
    }
  }
}
